import React from 'react';
import { pageDefinition } from 'site-modules/shared/pages/page';
import { BasicsScreen } from 'client/site-modules/financing/components/basics-screen/basics-screen';
import { FinancingDecorator } from 'client/site-modules/financing/decorators/financing-decorator';
import { FinancingDecoratorFactoryPreload } from './financing-model-preloader';
import { getSeoObject } from './seo';

export const pageDefinitionConfiguration = {
  name: 'financing_basics',
  category: 'financing',
  decorator: FinancingDecorator,
  preload: FinancingDecoratorFactoryPreload,
  seo: getSeoObject,
  component: options => (
    <BasicsScreen
      enableNextBtn={options.enableNextBtn}
      changePageState={options.changePageState}
      isMatchingVIN={options.isMatchingVIN}
      setFormData={options.setFormData}
      isPreVinFlow={options.isPreVinFlow}
    />
  ),
  options: {
    disableScrollToTop: true,
  },
};

export default pageDefinition(pageDefinitionConfiguration);
